// import {
//   Box,
//   Card,
//   CardContent,
//   Container,
//   Skeleton,
//   Typography,
// } from "@mui/material";
// import React, { useEffect, useState } from "react";
// import { useCookies } from "react-cookie";
// import { config } from "../../../config/config";
// import "swiper/css";
// import "swiper/css/pagination";
// import "swiper/css/navigation";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { apiList, invokeApi } from "../../../apis/apiServices";
// import { useNavigate } from "react-router-dom";
// // import required modules
// import { Pagination, Navigation, Autoplay } from "swiper/modules";
// import PropertyCard from "./PropertyCard";
// import LeadForm from "../../end-user/PropertyDetails/LeadForm";

// const ExclusivePropertySection = () => {
//   const [cookies] = useCookies();
//   const navigate = useNavigate();

//   const [leadModal, setLeadModal] = useState(false);
//   const [leadSource, setLeadSource] = useState("");
//   const [propertyId, setPropertyId] = useState(null);

//   const [isPropertiesFetching, setIsPropertiesFetching] = useState(true);
//   const [propertiesList, setPropertiesList] = useState([]);

//   const handeChangeModal = () => setLeadModal((prevState) => !prevState);

//   useEffect(() => {
//     const propertiesList = async () => {
//       let params = {
//         city: cookies[config.preferencesCookie]?.city || "Bangalore",
//       };
//       const response = await invokeApi(
//         config.apiDomains + apiList.allExclusiveProperties,
//         params,
//         cookies
//       );
//       if (response?.status >= 200 && response?.status < 300) {
//         if (response?.data.responseCode === "200") {
//           setPropertiesList(response.data.exclusiveProperties);
//         } else {
//           alert("An error occurred while fetching latest data!");
//         }
//       } else {
//         alert("An error occurred while fetching latest data!!");
//       }
//     };
//     if (isPropertiesFetching && !propertiesList.length > 0) {
//       propertiesList();
//       setIsPropertiesFetching(false);
//     }
//   }, [cookies, isPropertiesFetching]);

//   function handleEnquiry(propertyId, propertyType) {
//     handeChangeModal();
//     setPropertyId(propertyId);
//     setLeadSource(propertyType);
//   }

//   useEffect(() => {
//     setIsPropertiesFetching(true);
//   }, [cookies[config.preferencesCookie]?.city]);

//   return (
//     <>
//       {/* latest property list start  */}
//       <Box
//         component="section"
//         sx={{ py: { md: 10, xs: 5 } }}
//       >
//         <Container maxWidth={"lg"}>
//           <Box
//             sx={{
//               textAlign: "center",
//               margin: "20px 0",
//               position: "relative",
//               zIndex: 1,
//               "&::before": {
//                 content: '""',
//                 position: "absolute",
//                 top: "50%",
//                 left: "50%",
//                 transform: "translate(-50%, -50%)",
//                 width: "100%",
//                 height: "150%",
//                 // backgroundColor: "#f2f2f2",
//                 zIndex: -1,
//                 borderRadius: "10px",
//                 // boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.1)",
//               },
//             }}
//           >
//             <Typography
//               variant="h2"
//               sx={{
//                 fontWeight: "bold",
//                 fontSize: { md: "33px", xs: "20px" },
//                 position: "relative",
//                 zIndex: 2,
//                 background: "linear-gradient(90deg, #e74c3c 30%, #FFD700 100%)",
//                 WebkitBackgroundClip: "text",
//                 WebkitTextFillColor: "transparent",
//                 display: "inline-block",
//                 padding: "10px 20px",
//                 borderRadius: "10px",
//                 textShadow: "2px 2px 4px rgba(0, 0, 0, 0.1)",
//                 "& span": {
//                   color: "#FFD700",
//                   fontStyle: "italic",
//                 },
//               }}
//             >
//               Exclusive Properties in {cookies[config.preferencesCookie]?.city}
//             </Typography>
//           </Box>
//           <Swiper
//             watchSlidesProgress={true}
//             pagination={{ clickable: true }}
//             navigation={true}
//             modules={[Pagination, Navigation, Autoplay]}
//             autoplay={{
//               delay: 3000, // Adjust time interval (3000ms = 3 seconds)
//               disableOnInteraction: false, // Keeps autoplay running even after user interaction
//             }}
//             slidesPerView={1}
//             spaceBetween={10}
//             breakpoints={{
//               640: { slidesPerView: 2, spaceBetween: 10 },
//               1024: { slidesPerView: 3, spaceBetween: 15 },
//             }}
//             loop={true} // Enable loop only if enough slides
//             className="mySwiper"
//           >
//             {propertiesList.length > 0
//               ? propertiesList.map((property, index) => (
//                 <SwiperSlide key={index}>
//                   <PropertyCard property={property} handleEnquiry={() => handleEnquiry(property.propertyId, property.propertyType)} />
//                 </SwiperSlide>
//               ))
//               : Array.from({ length: 15 }, (_, index) => (
//                 <SwiperSlide key={index}>
//                   <SkeletonCard />
//                 </SwiperSlide>
//               ))}
//           </Swiper>
//         </Container>
//       </Box>
//       {/* latest property list end  */}

//       <LeadForm
//         isOpen={leadModal}
//         onClose={() => setLeadModal(false)}
//         leadSource={leadSource}
//         propertyId={propertyId}
//       />
//     </>
//   );
// };

// const Badge = ({ label }) => (
//   <Box sx={{ backgroundColor: "#EAEAEA", px: 1.5, py: 0.8, borderRadius: "8px", fontSize: "12px" }}>
//     {label}
//   </Box>
// );

// const SkeletonCard = () => (
//   <Card sx={{ margin: "0 5px", minHeight: "290px", zIndex: 1 }}>
//     <Skeleton variant="rectangular" width="100%" height={150} />
//     <CardContent sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
//       <Skeleton width="60%" />
//       <Box sx={{ display: "flex", gap: 1, mt: 2 }}>
//         <Skeleton width={80} height={30} />
//         <Skeleton width={80} height={30} />
//       </Box>
//     </CardContent>
//   </Card>
// );



// export default ExclusivePropertySection;








import {
  Box,
  Card,
  CardContent,
  Container,
  Skeleton,
  Typography,
  Chip,
  IconButton,
} from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import { useCookies } from "react-cookie";
import { config } from "../../../config/config";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Swiper, SwiperSlide } from "swiper/react";
import { apiList, invokeApi } from "../../../apis/apiServices";
import { useNavigate } from "react-router-dom";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import PropertyCard from "./PropertyCard";
import LeadForm from "../../end-user/PropertyDetails/LeadForm";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import StarIcon from '@mui/icons-material/Star';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';

const dummyProperties = [
  {
    propertyId: 1,
    propertyType: "Apartment",
    title: "Luxury 2 BHK Apartment",
    city: "Bangalore",
    price: 8500000,
    rent: 8500000,
    imageUrl: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
    area: "1200 sq.ft",
    location: "Whitefield",
    numOfBedrooms: 2,
    numOfBathrooms: 2,
  },
  {
    propertyId: 2,
    propertyType: "Villa",
    title: "Premium 3 BHK Villa",
    city: "Bangalore",
    price: 18000000,
    rent: 18000000,
    imageUrl: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
    area: "2400 sq.ft",
    location: "Sarjapur Road",
    numOfBedrooms: 3,
    numOfBathrooms: 3,
  },
  {
    propertyId: 3,
    propertyType: "Plot",
    title: "Residential Plot",
    city: "Bangalore",
    price: 6500000,
    rent: 6500000,
    imageUrl: "https://images.unsplash.com/photo-1568605114967-8130f3a36994?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
    area: "1500 sq.ft",
    location: "Yelahanka",
    numOfBedrooms: 0,
    numOfBathrooms: 0,
  },
  {
    propertyId: 4,
    propertyType: "Apartment",
    title: "Modern 3 BHK",
    city: "Bangalore",
    price: 12000000,
    rent: 12000000,
    imageUrl: "https://images.unsplash.com/photo-1518780664697-55e3ad937233?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
    area: "1500 sq.ft",
    location: "Electronic City",
    numOfBedrooms: 3,
    numOfBathrooms: 2,
  },
  {
    propertyId: 5,
    propertyType: "Apartment",
    title: "Luxury 4 BHK Penthouse",
    city: "Bangalore",
    price: 25000000,
    rent: 25000000,
    imageUrl: "https://images.unsplash.com/photo-1613977257363-707ba9348227?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
    area: "2800 sq.ft",
    location: "MG Road",
    numOfBedrooms: 4,
    numOfBathrooms: 3,
  },
  {
    propertyId: 6,
    propertyType: "Villa",
    title: "Premium 4 BHK Villa",
    city: "Bangalore",
    price: 35000000,
    rent: 35000000,
    imageUrl: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
    area: "3200 sq.ft",
    location: "Jayanagar",
    numOfBedrooms: 4,
    numOfBathrooms: 4,
  },
];

const ExclusivePropertySection = () => {
  const [cookies] = useCookies();
  const navigate = useNavigate();
  const swiperRef = useRef(null);

  const [leadModal, setLeadModal] = useState(false);
  const [leadSource, setLeadSource] = useState("");
  const [propertyId, setPropertyId] = useState(null);

  const [isPropertiesFetching, setIsPropertiesFetching] = useState(true);
  const [propertiesList, setPropertiesList] = useState([]);

  const handeChangeModal = () => setLeadModal((prevState) => !prevState);

  useEffect(() => {
    const fetchProperties = async () => {
      let params = {
        city: cookies[config.preferencesCookie]?.city || "Bangalore",
      };
      const response = await invokeApi(
        config.apiDomains + apiList.allExclusiveProperties,
        params,
        cookies
      );
      if (response?.status >= 200 && response?.status < 300) {
        if (response?.data.responseCode === "200") {
          setPropertiesList(response.data.exclusiveProperties);
        } else {
          alert("An error occurred while fetching latest data!");
        }
      } else {
        alert("An error occurred while fetching latest data!!");
      }
    };
    if (isPropertiesFetching && !propertiesList.length > 0) {
      fetchProperties();
      setIsPropertiesFetching(false);
    }
  }, [cookies, isPropertiesFetching]);

  function handleEnquiry(propertyId, propertyType) {
    handeChangeModal();
    setPropertyId(propertyId);
    setLeadSource(propertyType);
  }

  useEffect(() => {
    setIsPropertiesFetching(true);
  }, [cookies[config.preferencesCookie]?.city]);

  const finalPropertyList =
    propertiesList && propertiesList.length > 0
      ? propertiesList
      : dummyProperties;

  return (
    <>
      <Box
        component="section"
        sx={{
          py: { xs: 4, sm: 5, md: 6 },
          backgroundColor: '#ffffff',
          position: 'relative',
        }}
      >
        <Container
          maxWidth="lg"
          sx={{
            px: { xs: 2, sm: 3 },
            position: 'relative',
          }}
        >
          {/* Header */}
          <Box sx={{ textAlign: "center", mb: { xs: 3, sm: 4, md: 5 } }}>
            <Chip
              icon={<StarIcon />}
              label="EXCLUSIVE PROPERTIES"
              sx={{
                backgroundColor: '#fee2e2',
                color: '#dc2626',
                fontWeight: 700,
                mb: 2,
                px: 2,
                py: 1,
                fontSize: { xs: '0.7rem', sm: '0.75rem' },
                letterSpacing: '0.5px',
                '& .MuiChip-icon': {
                  color: '#dc2626',
                  fontSize: { xs: '16px', sm: '18px' }
                }
              }}
            />

            <Typography
              variant="h2"
              sx={{
                fontWeight: 700,
                fontSize: { xs: "24px", sm: "30px", md: "36px" },
                color: '#111827',
                mb: 1,
                lineHeight: 1.2,
              }}
            >
              Exclusive Properties in{' '}
              <Box
                component="span"
                sx={{
                  color: '#dc2626',
                  position: 'relative',
                  '&::after': {
                    content: '""',
                    position: 'absolute',
                    bottom: '2px',
                    left: 0,
                    width: '100%',
                    height: '4px',
                    backgroundColor: 'rgba(220, 38, 38, 0.1)',
                    borderRadius: '2px',
                  }
                }}
              >
                {cookies[config.preferencesCookie]?.city || "Bangalore"}
              </Box>
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: '#6b7280',
                fontSize: { xs: "14px", sm: "15px", md: "16px" },
                maxWidth: '600px',
                mx: 'auto',
                lineHeight: 1.6,
              }}
            >
              Discover handpicked premium properties with exceptional amenities
            </Typography>
          </Box>

          {/* Swiper Container with Arrows on Cards */}
          <Box sx={{
            position: 'relative',
            '& .swiper': {
              padding: '20px 10px 50px !important',
            },
            '& .swiper-pagination': {
              bottom: '20px !important',
              position: 'absolute',
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '8px',
            },
            '& .swiper-pagination-bullet': {
              width: '8px',
              height: '8px',
              backgroundColor: '#d1d5db',
              opacity: 1,
              transition: 'all 0.3s ease',
            },
            '& .swiper-pagination-bullet-active': {
              backgroundColor: '#dc2626',
              width: '24px',
              borderRadius: '4px',
            },
          }}>
            {/* Left Arrow - Positioned on left side of cards */}
            <IconButton
              onClick={() => swiperRef.current?.slidePrev()}
              sx={{
                position: 'absolute',
                left: { xs: '8px', sm: '0', md: '-20px' },
                top: '50%',
                transform: 'translateY(-50%)',
                backgroundColor: 'white',
                border: '1px solid #e5e7eb',
                width: { xs: 36, sm: 40, md: 44 },
                height: { xs: 36, sm: 40, md: 44 },
                zIndex: 10,
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                '&:hover': {
                  backgroundColor: '#dc2626',
                  color: 'white',
                  borderColor: '#dc2626',
                  transform: 'translateY(-50%) scale(1.05)',
                },
                transition: 'all 0.2s ease',
              }}
            >
              <NavigateBeforeIcon sx={{ fontSize: { xs: 18, sm: 20, md: 22 } }} />
            </IconButton>

            {/* Right Arrow - Positioned on right side of cards */}
            <IconButton
              onClick={() => swiperRef.current?.slideNext()}
              sx={{
                position: 'absolute',
                right: { xs: '8px', sm: '0', md: '-20px' },
                top: '50%',
                transform: 'translateY(-50%)',
                backgroundColor: 'white',
                border: '1px solid #e5e7eb',
                width: { xs: 36, sm: 40, md: 44 },
                height: { xs: 36, sm: 40, md: 44 },
                zIndex: 10,
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                '&:hover': {
                  backgroundColor: '#dc2626',
                  color: 'white',
                  borderColor: '#dc2626',
                  transform: 'translateY(-50%) scale(1.05)',
                },
                transition: 'all 0.2s ease',
              }}
            >
              <NavigateNextIcon sx={{ fontSize: { xs: 18, sm: 20, md: 22 } }} />
            </IconButton>

            {/* Swiper */}
            <Swiper
              onSwiper={(swiper) => {
                swiperRef.current = swiper;
              }}
              watchSlidesProgress={true}
              pagination={{
                clickable: true,
                dynamicBullets: false,
              }}
              navigation={false}
              modules={[Pagination, Navigation, Autoplay]}
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              slidesPerView={1}
              spaceBetween={20}
              breakpoints={{
                640: { slidesPerView: 2, spaceBetween: 20 },
                900: { slidesPerView: 3, spaceBetween: 24 },
                1200: { slidesPerView: 3, spaceBetween: 24 },
                1400: { slidesPerView: 3, spaceBetween: 24 },
              }}
              loop={true}
            >
              {finalPropertyList.length > 0
                ? finalPropertyList.map((property, index) => (
                  <SwiperSlide key={index}>
                    <PropertyCard
                      property={property}
                      handleEnquiry={() =>
                        handleEnquiry(property.propertyId, property.propertyType)
                      }
                    />
                  </SwiperSlide>
                ))
                : Array.from({ length: 3 }, (_, index) => (
                  <SwiperSlide key={index}>
                    <SkeletonCard />
                  </SwiperSlide>
                ))}
            </Swiper>
          </Box>

          {/* Property Count */}
          <Box sx={{ textAlign: 'center', mt: 3 }}>
            <Typography
              variant="body2"
              sx={{
                color: '#6b7280',
                fontSize: { xs: '13px', sm: '14px' },
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1,
              }}
            >
              <LocationOnIcon sx={{ fontSize: { xs: 14, sm: 16 }, color: '#dc2626' }} />
              Showing {finalPropertyList.length} exclusive properties
            </Typography>
          </Box>
        </Container>
      </Box>

      <LeadForm
        isOpen={leadModal}
        onClose={() => setLeadModal(false)}
        leadSource={leadSource}
        propertyId={propertyId}
      />
    </>
  );
};

const SkeletonCard = () => (
  <Card
    sx={{
      height: '100%',
      borderRadius: '8px',
      overflow: 'hidden',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      display: 'flex',
      flexDirection: 'column',
    }}
  >
    <Skeleton
      variant="rectangular"
      width="100%"
      height={180}
      sx={{ bgcolor: '#f3f4f6' }}
    />
    <CardContent sx={{ p: 2.5, flex: 1, display: 'flex', flexDirection: 'column' }}>
      <Skeleton
        width="80%"
        height={20}
        sx={{ mb: 1.5, bgcolor: '#f3f4f6' }}
      />
      <Skeleton
        width="60%"
        height={18}
        sx={{ mb: 2, bgcolor: '#f3f4f6' }}
      />
      <Box sx={{
        display: 'flex',
        gap: { xs: 1, sm: 1.5 },
        mb: 2,
        justifyContent: 'center',
        alignItems: 'center',
      }}>
        <Skeleton
          width={70}
          height={26}
          sx={{ borderRadius: '4px', bgcolor: '#f3f4f6' }}
        />
        <Skeleton
          width={70}
          height={26}
          sx={{ borderRadius: '4px', bgcolor: '#f3f4f6' }}
        />
        <Skeleton
          width={70}
          height={26}
          sx={{ borderRadius: '4px', bgcolor: '#f3f4f6' }}
        />
      </Box>
      <Box sx={{
        display: 'flex',
        gap: 1,
        mt: 'auto',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}>
        <Skeleton
          width="48%"
          height={36}
          sx={{ borderRadius: '6px', bgcolor: '#f3f4f6' }}
        />
        <Skeleton
          width="48%"
          height={36}
          sx={{ borderRadius: '6px', bgcolor: '#f3f4f6' }}
        />
      </Box>
    </CardContent>
  </Card>
);

export default ExclusivePropertySection;